import { Component, Inject } from '@angular/core';
import { ApiservicesService } from '../services/apiservices.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MysteryStripeModal } from '../mystery-school/mystery-school-dashboard/mystery-school-dashboard.component';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../shared/shared.module';
import { DialogData } from 'listing-angular15';

@Component({
  selector: 'app-mystery-school-signup',
  templateUrl: './mystery-school-signup.component.html',
  styleUrls: ['./mystery-school-signup.component.scss'],
})
export class MysterySchoolSignupComponent {
  constructor(
    private apiService: ApiservicesService,
    public cookieService: CookieService,
    public matSnackBar: MatSnackBar,
    public location: Location,
    public activateRoute: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
  ) {}
  public configFormData = {};
  public formfieldrefresh: any = null;
  public formfieldrefreshdata: any = null;
  public formLoader: boolean = false;
  public login_user_details: any = {};
  public paramsId: any = '';
  public webinarList: Array<Object> = [];
  public stateList: any = [];
  emailregex: RegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  formValue: any = null;
  lodedValue: any = {};
  forUpdate: boolean = false;
  update_id: any = '';
  user_email: any = '';
  statusarr: any = [
    { val: 1, name: 'Active' },
    { val: 0, name: 'Inactive' },
  ];


  ngOnInit() {
    this.getStates();
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};

    this.paramsId = this.activateRoute.snapshot.params['_id'];

    if (
      this.activateRoute.snapshot.params &&
      this.activateRoute.snapshot.params['_id']
    ) {
      this.activateRoute.data.subscribe((response: any) => {
        console.log('edit data', response);
        if (response.data && response.data.status == 'success') {
          this.formValue = response.data.res;
          this.update_id = response.data.res._id;
          this.user_email = response.data.res.email;
          this.forUpdate = true;
          console.log('this.formValue----->', this.formValue);
        }
      });
    }
    this.configForm();
  }

  getStates() {
    this.apiService.getHttpData('user/states').subscribe((response) => {
      if (response.results.res && response.results.res.length > 0) {
        response.results.res.forEach((e: any, i: number) => {
          let obj = { val: e.abbreviation, name: e.name };
          this.stateList.push(obj);
        });
      }
      console.log(this.stateList, 'stateList');
    });
  }

  configForm() {
    console.log('this is anglu edit form', this.formValue);

    let editFields = [];
    if (this.formValue) {
    }

    this.configFormData = {
      successmessage: 'Added Successfully !!',
      submittext: 'Submit',
      apiUrl: this.apiService.baseUrl,
      resettext: 'Reset',
      canceltext: 'Cancel',
      hidereset: true,
      jwttoken: '',
      // groups: ['grp0', 'grp1', 'grp2', 'grp3', 'grp4', 'grp5', 'grp6', 'grp7'],
      fields: [
        {
          label: 'First Name',
          name: 'firstname',
          value: this.formValue?.firstname ? this.formValue.firstname : '',
          type: 'text',

          classname: 'aaa',
          validations: [
            { rule: 'required', message: 'First Name is Required' },
          ],
        },
        {
          label: 'Last Name',
          name: 'lastname',
          value: this.formValue?.lastname ? this.formValue.lastname : '',
          type: 'text',

          classname: 'aaa',
          validations: [{ rule: 'required', message: 'Last Name is Required' }],
        },
        {
          label: 'Phone',
          name: 'phone',
          value:
            this.formValue && this.formValue.phone ? this.formValue.phone : '',
          type: 'numberformat',
          formatflag: true,

          classname: 'aaa',
          validations: [{ rule: 'required', message: 'Phone is Required' }],
        },
        {
          label: 'Email',
          name: 'email',
          value:
            this.formValue && this.formValue.email ? this.formValue.email : '',
          disabled: this.formValue && this.formValue.email ? true : false,
          type: 'email',
          validations: [
            { rule: 'required', message: 'Email is Required' },
            {
              rule: 'pattern',
              value: this.emailregex,
              message: 'Must be a valid Email',
            },
          ],
        },
        {
          label: 'Date of Birth',
          name: 'dob',
          value: this.formValue && this.formValue.dob ? this.formValue.dob : '',
          type: 'date',

          // minDate: new Date(),
          validations: [
            { rule: 'required', message: 'Date of Birth is Required' },
          ],
        },
        {
          label: 'Time of Birth',
          name: 'time_of_birth',
          type: 'timepicker2',
          value:
            this.formValue && this.formValue.time_of_birth
              ? this.formValue.time_of_birth
              : '',
          format: 24,
          validations: [
            { rule: 'required', message: 'Time of Birth is Required' },
          ],
        },
        {
          label: 'State',
          name: 'state',
          type: 'select',
          val: this.stateList,
          multiple: false,
          value:
            this.formValue && this.formValue.state ? this.formValue.state : '',
          validations: [{ rule: 'required', message: 'State is Required' }],
        },
        {
          label: 'City (e.g. Atlanta)',
          name: 'city',
          value:
            this.formValue && this.formValue.city ? this.formValue.city : '',
          type: 'text',
          validations: [{ rule: 'required', message: 'City is Required' }],
        },

        {
          label: 'Zip',
          name: 'zip',
          value: this.formValue && this.formValue.zip ? this.formValue.zip : '',
          type: 'number',
          validations: [{ rule: 'required', message: 'Zip is Required' }],
        },
        {
          label: 'Gender',
          name: 'gender',
          type: 'select',
          value:
            this.formValue && this.formValue.gender
              ? this.formValue.gender
              : '',
          val: [
            { val: 'male', name: 'Male' },
            { val: 'female', name: 'Female' },
            { val: 'others', name: 'Others' },
          ],
          multiple: false,
          validations: [{ rule: 'required', message: 'Gender is Required' }],
        },
        {
          label: 'Occupation',
          name: 'occupation',
          value:
            this.formValue && this.formValue.occupation
              ? this.formValue.occupation
              : '',
          type: 'text',
          // validations: [
          //   { rule: 'required', message: 'Occupation is Required' },
          // ],
        },
        {
          label: 'Relationship Status',
          name: 'relationship_status',
          type: 'select',
          val: [
            { val: 'single', name: 'Single' },
            { val: 'married', name: 'Married' },
            { val: 'separated', name: 'Separated' },
            { val: 'divorced', name: 'Divorced' },
            { val: 'widowed', name: 'Widowed' },
          ],
          value:
            this.formValue && this.formValue.relationship_status
              ? this.formValue.relationship_status
              : 'single',
          multiple: false,
          // validations: [
          //   { rule: 'required', message: 'Relationship Status is Required' },
          // ],
        },
        {
          label: 'Address',
          name: 'address',
          type: 'textarea',
          value:
            this.formValue && this.formValue.address
              ? this.formValue.address
              : '',
          validations: [{ rule: 'required', message: 'Address is Required' }],
        },
        {
          label: 'More about yourself',
          name: 'additional_info',
          type: 'textarea',
          value:
            this.formValue && this.formValue.additional_info
              ? this.formValue.additional_info
              : '',
        },

        // ...editFields,

        {
          label: 'Season Type',
          name: 'Product_Deck',
          type: 'select',
          val: [
            { val: 'Astro Toolkit', name: 'Astro Toolkit' },
            { val: 'Tarot Toolkit', name: 'Tarot Toolkit' },
          ],
          value:
            this.formValue && this.formValue.Product_Deck
              ? this.formValue.Product_Deck
              : 'Astro Toolkit',
          multiple: false,
          validations: [
            { rule: 'required', message: 'Season Type is Required' },
          ],
        },
        {
          label: 'Product/Deck',
          name: 'Product_Deck_name',
          type: 'select',
          val: [
            { val: 'Nativity Birth Chart', name: 'Nativity Birth Chart' },
            { val: 'Solar Return', name: 'Solar Return' },
            { val: 'Weekly Transits', name: 'Weekly Transits' },
            {
              val: 'Monthly Transits + Lunar Return',
              name: 'Monthly Transits + Lunar Return',
            },
            { val: 'Romantic Relationships', name: 'Romantic Relationships' },
            {
              val: 'Friendship Relationships',
              name: 'Friendship Relationships',
            },
            { val: 'Business Relationship', name: 'Business Relationship' },
            {
              val: 'Predictive Event (Horary)',
              name: 'Predictive Event (Horary)',
            },
            { val: 'Jupiter Return', name: 'Jupiter Return' },
            { val: 'Saturn Return', name: 'Saturn Return' },
            { val: 'Mars Return', name: 'Mars Return' },
          ],
          value:
            this.formValue && this.formValue.Product_Deck_name
              ? this.formValue.Product_Deck_name
              : 'Nativity Birth Chart',
          multiple: false,
          validations: [
            { rule: 'required', message: 'Product/Deck is Required' },
          ],
        },
        {
          label: 'Describe Your Personality',
          name: 'describe_your_personality',
          type: 'textarea',
          value:
            this.formValue && this.formValue.describe_your_personality
              ? this.formValue.describe_your_personality
              : '',
        },
        {
          label: 'Primary Strengths and Talents',
          name: 'primary_sengths_talents',
          type: 'textarea',
          value:
            this.formValue && this.formValue.primary_sengths_talents
              ? this.formValue.primary_sengths_talents
              : '',
        },
        {
          label: 'Life Areas Currently Fulfilling',
          name: 'life_areas_currently_fulfilling',
          type: 'text',
          rows: 1,
          cols: 2,
          value:
            this.formValue && this.formValue.life_areas_currently_fulfilling
              ? this.formValue.life_areas_currently_fulfilling
              : '',
        },
        {
          label: 'Life Areas Needing Improvement',
          name: 'life_areas_needing_improvement',
          type: 'text',
          rows: 1,
          cols: 2,
          value:
            this.formValue && this.formValue.life_areas_needing_improvement
              ? this.formValue.life_areas_needing_improvement
              : '',
        },
        {
          label: 'Long-Term Goals and Aspirations',
          name: 'long_term_goals_and_aspirations',
          type: 'text',
          rows: 1,
          cols: 2,
          value:
            this.formValue && this.formValue.long_term_goals_and_aspirations
              ? this.formValue.long_term_goals_and_aspirations
              : '',
        },
        {
          label: 'Major Life Events/Experiences',
          name: 'major_life_events_experiences',
          type: 'text',
          rows: 1,
          cols: 2,
          value:
            this.formValue && this.formValue.major_life_events_experiences
              ? this.formValue.major_life_events_experiences
              : '',
        },
        {
          label:
            'Stress Management (Do you find it challenging to handle stress? Yes/No)',
          name: 'stress_management',
          type: 'checkbox',
          value: this.formValue?.stress_management
            ? this.formValue.stress_management
            : false,
        },
        {
          label:
            'Work-Life Balance (Do you feel you have a good balance? Yes/No)',
          name: 'Work_Life_balance',
          type: 'checkbox',
          value: this.formValue?.Work_Life_balance
            ? this.formValue.Work_Life_balance
            : false,
        },
        {
          label: 'Current Relationship with Family and Friends',
          name: 'current_relationship_with_family_and_friends',
          type: 'textarea',
          value:
            this.formValue &&
            this.formValue.current_relationship_with_family_and_friends
              ? this.formValue.current_relationship_with_family_and_friends
              : '',
        },
        {
          label: 'Focus on Specific Relationships (Yes/No)',
          name: 'focus_on_specific_relationships',
          type: 'checkbox',
          value: this.formValue?.focus_on_specific_relationships
            ? this.formValue.focus_on_specific_relationships
            : false,
        },
        {
          label: 'Concerns About Romantic Life (Yes/No)',
          name: 'concerns_about_romantic_life',
          type: 'checkbox',
          value: this.formValue?.concerns_about_romantic_life
            ? this.formValue.concerns_about_romantic_life
            : false,
        },
        {
          label: 'Social Life Fulfillment (Yes/No)',
          name: 'social_life_fulfillment',
          type: 'checkbox',
          value: this.formValue?.social_life_fulfillment
            ? this.formValue.social_life_fulfillment
            : false,
        },
        {
          label: 'Biggest Current Challenges',
          name: 'biggest_current_challenges',
          type: 'textarea',
          value:
            this.formValue && this.formValue.biggest_current_challenges
              ? this.formValue.biggest_current_challenges
              : '',
        },
        
        {
          label: 'Guidance on Specific Decision/Situation (Yes/No)',
          name: 'guidance_on_specific_decision',
          type: 'checkbox',
          value: this.formValue?.guidance_on_specific_decision
            ? this.formValue.guidance_on_specific_decision
            : false,
        },
        
        {
          label: 'Ongoing Projects or Plans (Yes/No)',
          name: 'ongoing_projects',
          type: 'checkbox',
          value: this.formValue?.ongoing_projects
            ? this.formValue.ongoing_projects
            : false,
        },
        
        {
          label: 'Achieve from the Reading',
          name: 'achieve_from_the_reading',
          type: 'textarea',
          value:
            this.formValue && this.formValue.achieve_from_the_reading
              ? this.formValue.achieve_from_the_reading
              : '',
        },
        {
          label: 'Specific Questions/Topics to Address',
          name: 'specific_questions_topics_to_address',
          type: 'checkbox',
          value: this.formValue?.specific_questions_topics_to_address
            ? this.formValue.specific_questions_topics_to_address
            : false,
        },
        {
          label: 'Goals or Outcomes for the Readin',
          name: 'goals_or_outcomes_for_the_reading',
          type: 'checkbox',
          value: this.formValue?.goals_or_outcomes_for_the_reading
            ? this.formValue.goals_or_outcomes_for_the_reading
            : false,
        },
        {
          label: 'Preference for Practical Advice vs. Spiritual Insights',
          name: 'Preference_for_practical_advice_vs_spiritual_insights',
          type: 'checkbox',
          value: this.formValue
            ?.Preference_for_practical_advice_vs_spiritual_insights
            ? this.formValue
                .Preference_for_practical_advice_vs_spiritual_insights
            : false,
        },
        {
          label: 'Spiritual or Personal Growth Practices',
          name: 'spiritual_or_personal_growth_practices',
          type: 'checkbox',
          value: this.formValue?.spiritual_or_personal_growth_practices
            ? this.formValue.spiritual_or_personal_growth_practices
            : false,
        },
        {
          label: 'Exploring Self-Discovery/Personal Development',
          name: 'exploring_self_discovery',
          type: 'checkbox',
          value: this.formValue?.exploring_self_discovery
            ? this.formValue.exploring_self_discovery
            : false,
        },
        
        {
          label: 'Belief in External Influences on Life (Yes/No)',
          name: 'belief_in_external_influences_on_life',
          type: 'checkbox',
          value: this.formValue?.belief_in_external_influences_on_life
            ? this.formValue.belief_in_external_influences_on_life
            : false,
        },
      {
          label: 'Main Concern or Question Right Now',
          name: 'main_concern_or_question_right_now',
          type: 'textarea',
          value:
            this.formValue && this.formValue.main_concern_or_question_right_now
              ? this.formValue.main_concern_or_question_right_now
              : '',
        },
        {
          label: 'Anything Else to Share',
          name: 'anything_else_to_share',
          type: 'textarea',
          value:
            this.formValue && this.formValue.anything_else_to_share
              ? this.formValue.anything_else_to_share
              : '',
        },
        
        {
          label: 'Concerns/Reservations About the Consultation (Yes/No)',
          name: 'concerns_reservations_about_the_consultation',
          type: 'checkbox',
          value: this.formValue
            ?.concerns_reservations_about_the_consultation
            ? this.formValue
                .concerns_reservations_about_the_consultation
            : false,
        }
      ],
    };
  }

  listenFormFieldChange(val: any) {
    console.log('button clicked', val);

    let dataobj = val.source?.data;

    if (val.field.name == 'Product_Deck' && val.fieldval == 'Tarot Toolkit') {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'Product_Deck_name' },
        };
      }, 350);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Product/Deck',
              name: 'Product_Deck_name',
              type: 'select',
              after: 'Product_Deck',
              val: [
                {
                  val: '3 Card Basic Question Spread',
                  name: '3 Card Basic Question Spread',
                },
                {
                  val: '5 Card Complex Question Spread',
                  name: '5 Card Complex Question Spread',
                },
                {
                  val: '7 Card 6 month forward review',
                  name: '7 Card 6 month forward review',
                },
                {
                  val: '7 Card Horseshoe Spread (Major read)',
                  name: '7 Card Horseshoe Spread (Major read)',
                },
                {
                  val: '10 Card Relationship Spread',
                  name: '10 Card Relationship Spread',
                },
                {
                  val: '10 Card Celtic Cross (Major read)',
                  name: '10 Card Celtic Cross (Major read)',
                },
                {
                  val: '12 Card Astrological Spread (Major read)',
                  name: '12 Card Astrological Spread (Major read)',
                },
              ],
              value:
                this.formValue && this.formValue.Product_Deck_name
                  ? this.formValue.Product_Deck_name
                  : '3 Card Basic Question Spread',
              multiple: false,
              validations: [
                { rule: 'required', message: 'Product/Deck is Required' },
              ],
            },
          ],
        };
      }, 400);
    }

    if (val.field.name == 'Product_Deck' && val.fieldval == 'Astro Toolkit') {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'Product_Deck_name' },
        };
      }, 350);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Product/Deck',
              name: 'Product_Deck_name',
              type: 'select',
              after: 'Product_Deck',
              val: [
                { val: 'Nativity Birth Chart', name: 'Nativity Birth Chart' },
                { val: 'Solar Return', name: 'Solar Return' },
                { val: 'Weekly Transits', name: 'Weekly Transits' },
                {
                  val: 'Monthly Transits + Lunar Return',
                  name: 'Monthly Transits + Lunar Return',
                },
                {
                  val: 'Romantic Relationships',
                  name: 'Romantic Relationships',
                },
                {
                  val: 'Friendship Relationships',
                  name: 'Friendship Relationships',
                },
                { val: 'Business Relationship', name: 'Business Relationship' },
                {
                  val: 'Predictive Event (Horary)',
                  name: 'Predictive Event (Horary)',
                },
                { val: 'Jupiter Return', name: 'Jupiter Return' },
                { val: 'Saturn Return', name: 'Saturn Return' },
                { val: 'Mars Return', name: 'Mars Return' },
              ],
              value:
                this.formValue && this.formValue.Product_Deck_name
                  ? this.formValue.Product_Deck_name
                  : 'Nativity Birth Chart',
              multiple: false,
              validations: [
                { rule: 'required', message: 'Product/Deck is Required' },
              ],
            },
          ],
        };
      }, 400);
    }

    if (
      val.field.name == 'Product_Deck_name' &&
      (val.fieldval == 'Solar Return' ||
        val.fieldval == 'Nativity Birth Chart' ||
        val.fieldval == 'Jupiter Return' ||
        val.fieldval == 'Saturn Return' ||
        val.fieldval == 'Mars Return')
    ) {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);
    }

    if (
      val.field.name == 'Product_Deck_name' &&
      val.fieldval == 'Weekly Transits'
    ) {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Select Week',
              name: 'selected_week',
              value:
                this.formValue && this.formValue.selected_week
                  ? this.formValue.selected_week
                  : '',
              type: 'date',
              after: 'Product_Deck_name',
              minDate: new Date(),
              validations: [{ rule: 'required', message: 'Week is Required' }],
            },
          ],
        };
      }, 350);
    }

    if (
      val.field.name == 'Product_Deck_name' &&
      val.fieldval == 'Monthly Transits + Lunar Return'
    ) {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Select Month',
              name: 'selected_month',
              value:
                this.formValue && this.formValue.selected_month
                  ? this.formValue.selected_month
                  : '',
              type: 'date',
              after: 'Product_Deck_name',
              minDate: new Date(),
              validations: [{ rule: 'required', message: 'Month is Required' }],
            },
          ],
        };
      }, 350);
    }

    if (
      val.field.name == 'Product_Deck_name' &&
      (val.fieldval == 'Romantic Relationships' ||
        val.fieldval == 'Friendship Relationships' ||
        val.fieldval == 'Business Relationship')
    ) {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Partner Date of Birth',
              name: 'partner_dob',
              value:
                this.formValue && this.formValue.partner_dob
                  ? this.formValue.partner_dob
                  : '',
              type: 'date',
              after: 'Product_Deck_name',
              // minDate: new Date(),
              validations: [
                {
                  rule: 'required',
                  message: 'Partner Date of Birth is Required',
                },
              ],
            },
            {
              label: 'Partner Time of Birth',
              name: 'partner_time_of_birth',
              type: 'timepicker2',
              after: 'partner_dob',
              value:
                this.formValue && this.formValue.partner_time_of_birth
                  ? this.formValue.partner_time_of_birth
                  : '',
              format: 24,
              validations: [
                {
                  rule: 'required',
                  message: 'Partner Time of Birth is Required',
                },
              ],
            },
            {
              label: 'Partner City (e.g. Atlanta)',
              name: 'partner_city',
              after: 'partner_time_of_birth',
              value:
                this.formValue && this.formValue.partner_city
                  ? this.formValue.partner_city
                  : '',
              type: 'text',
              validations: [
                { rule: 'required', message: 'Partner City is Required' },
              ],
            },
          ],
        };
      }, 350);
    }

    if (
      val.field.name == 'Product_Deck_name' &&
      val.fieldval == 'Predictive Event (Horary)'
    ) {
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_month' },
        };
      }, 50);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'selected_week' },
        };
      }, 100);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_dob' },
        };
      }, 150);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_time_of_birth' },
        };
      }, 200);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'partner_city' },
        };
      }, 250);
      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'removefromcontrol',
          value: { name: 'your_question' },
        };
      }, 300);

      setTimeout(() => {
        this.formfieldrefreshdata = {
          field: 'addfromcontrol',
          value: [
            {
              label: 'Your Question',
              name: 'your_question',
              type: 'textarea',
              after: 'Product_Deck_name',
              value:
                this.formValue && this.formValue.your_question
                  ? this.formValue.your_question
                  : '',
              validations: [
                { rule: 'required', message: 'Your Question is Required' },
              ],
            },
          ],
        };
      }, 350);
    }

    if (val.field === 'fromsubmit' && val.fieldval === 'success') {
      
      let hasEmptyOptionalFields = false;
      const formFieldsConfig = (this.configFormData as any)?.fields;

      if (Array.isArray(formFieldsConfig)) {
        for (const fieldConfig of formFieldsConfig) {
          const fieldName = fieldConfig.name;
          const fieldValue = dataobj[fieldName];
          const isRequired = fieldConfig.validations?.some((v: any) => v.rule === 'required');

          if (!isRequired && fieldConfig.type !== 'checkbox') {
            if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
              console.log(`Optional field '${fieldName}' is empty. Value: '${fieldValue}'`);
              hasEmptyOptionalFields = true;
              break;
            }
          }
        }
      }

      if (hasEmptyOptionalFields) {
        const dialogRef = this.dialog.open(MysterySignupConfirmationModal, {
          panelClass: ['custom-modalbox', 'mystery-signup-confirmation-modal'],
        });
        dialogRef.afterClosed().subscribe(confirmed => {
          if (confirmed) {
            this.proceedWithSignup(dataobj);
          } 
        });
      } else {
        this.proceedWithSignup(dataobj);
      }
    }

    if (val.field && val.field == 'formreset') {
      this.formfieldrefreshdata = {
        field: 'description',
        value: '',
      };
    }
    if (val.field && val.field == 'formcancel') {
      this.location.back();
    }
  }


  proceedWithSignup(dataobj: any) {
      this.formLoader = true;

      if (this.update_id) dataobj['_id'] = this.update_id;
      if(this.user_email) dataobj['email'] = this.user_email;
      dataobj['from_mysteryschool'] = true;

      this.apiService
        .getHttpDataPost(
          'user/signup',
          dataobj
        )
        .subscribe({
          next: (res: any) => {
            console.log('res', res);
            if(res.status == 'success') {
              this.matSnackBar.open(res.message, 'Ok', {
                duration: 5000}
              )
              let body = {
                customer_email: dataobj.email,
                user_id: dataobj._id,
              };
      
              this.apiService
                .getHttpDataPost('stripe/create-subscription-mystery-school', body)
                .subscribe((response) => {
                  console.log('response', response);
                  if (response.status == 'success') {
                    console.log('response', response);
                    this.openStripe({ ...response.results, ...body });
                  }
                });
              this.formLoader = false;
            } else {
              this.matSnackBar.open('Something went wrong !!', 'Ok', {
                duration: 5000}
              )
              this.formLoader = false;
            }
          },
          error: (err) => {
            console.log('err', err);
            this.matSnackBar.open(err.message || 'Something went wrong !!', 'Ok', {
              duration: 5000}
            )
            this.formLoader = false;
          },
        });
  }

  openStripe(dataObj: any) {
      const dialogRef = this.dialog.open(MysteryStripeModal, {
        panelClass: ['custom-modalbox', 'stripe-modalbox'],
        data: {
          dataObj: dataObj,
        },
      });
    }

}



// << ------------------ Subscription Modal ------------------ >>

@Component({
  selector: 'MysterySignupConfirmationModal',
  templateUrl: './mystery-signup-confirmation-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class MysterySignupConfirmationModal {

  constructor(
    public dialogRef: MatDialogRef<MysterySignupConfirmationModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar
  ) {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}